"use client";

import {
  ISpecificationCategoryOrItemResponse,
  ISpecificationCategoryResponse,
} from "@/shared/services/interface/responses/ISpecificationResponse";
import RenderCollapsible from "./category-collapsible/category-collapsible";
import SpecificationSidebarSkeleton from "../../skeleton";
import { useSelector } from "@/core/redux/store";
import { cn } from "@/lib/utils";
import { categoryMatchesSearch } from "@/core/redux/helper/specification";

export function SpecificationCategoryList({
  categories,
  parentPriority,
  disableEdit = false,
  parentId = null,
  subIndex,
  prevItemId,
  nextItemId,
}: {
  categories: ISpecificationCategoryResponse[];
  parentPriority?: string;
  disableEdit?: boolean;
  parentId?: string | null;
  subIndex?: number;
  prevItemId?: string | null;
  nextItemId?: string | null;
}) {
  const skeletonLoading = useSelector(
    (state) => state.specification.skeletonLoading
  );
  const searchTerm = useSelector((state) => state.specification.searchTerm);
  const categoriesTotal = categories?.length || 0;
  
  return (
    <div
      className={cn("pt-0 overflow-auto", {
        "max-h-[calc(100vh-149px)]": parentId === null,
      })}
    >
      <div className="flex flex-col gap-0">
        {categories?.map((item, index) => {
          // Check if category matches search - if not, don't render
          if (!categoryMatchesSearch(item, searchTerm)) {
            return null;
          }
          
          const prevItemId_ =
            prevItemId || (index === 0 ? null : categories[index - 1].id);
          const nextItemId_ =
            nextItemId ||
            (index === categories.length - 1 ? null : categories[index + 1].id);
          index === categories.length - 1 ? null : categories[index + 1].id;
          return (
            <RenderCollapsible
              item={item}
              key={item.id}
              priority={
                categoriesTotal > 1
                  ? parentPriority
                    ? `${parentPriority}.${index + 1}`
                    : `${index + 1}`
                  : parentPriority
                  ? `${parentPriority}.${
                      subIndex || subIndex === 0 ? subIndex + 1 : 1
                    }`
                  : `${subIndex || subIndex === 0 ? subIndex + 1 : 1}`
              }
              disableEdit={disableEdit}
              parentId={parentId}
              prevItemId={prevItemId_}
              nextItemId={nextItemId_}
            />
          );
        })}
        {categories?.length === 0 && skeletonLoading && (
          <SpecificationSidebarSkeleton />
        )}
      </div>
    </div>
  );
}

export default SpecificationCategoryList;
